export const AVATARS = Array.from({ length: 8 }, (_, index) => {
  const number = String(index + 1).padStart(2, '0')
  return { filename: `avatar-${number}.webp`, label: `头像 ${index + 1}` }
})

export const DEFAULT_AVATAR = AVATARS[0].filename

export function avatarUrl(filename) {
  return `/avatars/${filename || DEFAULT_AVATAR}`
}
